import { render, staticRenderFns } from "./EditFeriados.vue?vue&type=template&id=b3b8aac8&scoped=true"
import script from "./EditFeriados.vue?vue&type=script&lang=js"
export * from "./EditFeriados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b8aac8",
  null
  
)

export default component.exports